export enum LaboratoryTemplateType {
	WORKPLACE = 'WORKPLACE',
	DOCTOR = 'DOCTOR',
}
